<template>
  <div>
    <div v-for="utilityPod in utilityNodesErrors" v-bind:key="utilityPod.pod.id" class="bg-error">
      {{$replaceT(utilityPod.error.code, utilityPod.error.params, utilityPod.error.content)}}
    </div>
  </div>
</template>

<script>
import { useServiceStore } from '@/stores/ServiceStore.js'

export default {
  name: "UtilityNodesErrors",
  mounted: function() {
    const serviceStore = useServiceStore();
    serviceStore.resetUtilityNodes();
  },
  computed: {
    utilityNodesErrors: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getUtilityNodesErrors;
    },
  }
}
</script>

<style>

</style>
